import * as React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import * as api from '../../api';

import { MultiEnum } from './MultiEnum';
import { getOptionsFromRecord } from '../utils';
import Enum from './Enum';

interface Props {
  navigateToNextPage: () => Promise<void>;
  raceOptions: api.Patient.Race[];
  onChange: (value: string) => Promise<void>;
  useAlternateEnum: boolean;
  value?: string;
  multi?: boolean;
}

const DefaultRaces = [
  api.Patient.Race.African,
  api.Patient.Race.AmericanIndian,
  api.Patient.Race.Asian,
  api.Patient.Race.Caucasian,
  api.Patient.Race.PacificIslander,
  api.Patient.Race.PatientDeclined,
  api.Patient.Race.Other,
];
const DefaultRaceOptions = _.pick(api.Previsit.raceMap, DefaultRaces);

export const RaceInput: React.FC<Props> = ({
  raceOptions,
  onChange,
  value,
  useAlternateEnum,
  multi,
}) => {
  const { t } = useTranslation();
  const displayOptions = getOptionsFromRecord(
    raceOptions.length
      ? _.pick(api.Previsit.raceMap, raceOptions)
      : DefaultRaceOptions,
    t,
  );
  const values: string[] = value ? JSON.parse(value) : [];
  const options =
    _.map(displayOptions, (value) => value || '').filter((x) => !!x) ||
    undefined;
  if (!multi) {
    return (
      <Enum
        value={values[0]}
        options={options}
        useAlternateEnum={useAlternateEnum}
        onChange={async (option) => {
          const formattedOption = JSON.stringify(option ? [option] : []);
          onChange(formattedOption);
        }}
      />
    );
  }
  return (
    <MultiEnum
      values={values}
      options={options}
      onChange={async (options) => onChange(options)}
    />
  );
};
